<template>
  <div class="filter-section">
    <div
      v-for="(item, index) in filterItem.taxonomy"
      :key="item.id + item.name + item.slug + index"
      class="filter-section-content justify-content-between"
    >
      <a class="inline" :href="item.path">{{ item.name }}</a>
      <span v-if="filterItem.count_display"> ({{ item.count || 0 }}) </span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["filterItem"],
};
</script>
<style scoped lang='scss'>
.filter-section {
  text-align: left;
  .filter-section-content {
    display: flex;
    margin-bottom: 10px;
    font-family: 'Muli';
    margin-bottom: 10px;
    &:hover {
      opacity: 0.7;
    }
  .inline {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    padding-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -o-ellipsis-lastline;
  }
    & > a,
    span {
      font-weight: 500;
      display: inline-block;
      color: #606266;
      line-height: 24px;
      font-size: 13px;
    }
    span {
      white-space: nowrap;
    }
  }
}
</style>